import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';

export default function AboutPage() {
  const { t } = useTranslation();

  const stats = [
    { value: '40+', label: '收录网站' },
    { value: '10', label: '分类覆盖' },
    { value: '99.9%', label: '可用率' },
    { value: '100%', label: '人工审核' },
  ];

  return (
    <>
      <Navbar />
      <main className="min-h-screen pt-16">
        <div className="max-w-4xl mx-auto px-4 md:px-6 py-6">
          <Breadcrumb items={[{ label: t('about') }]} />

          <section className="mb-14">
            <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-6">
              {t('aboutTitle')}
            </h1>

            <div className="prose prose-sm md:prose-base max-w-none text-foreground-700 leading-relaxed
              [&_p]:mb-4 [&_p]:leading-relaxed
              [&_strong]:text-foreground-900 [&_strong]:font-semibold"
            >
              <p>
                蓝色导航在线创立于2024年，是一个专注于<strong>网址导航与资源聚合</strong>的在线平台。
                我们的使命是帮助每一位互联网用户快速、准确地找到目标网站，让上网体验更加高效、愉悦。
              </p>
              <p>
                在信息爆炸的时代，搜索引擎返回的结果往往需要用户花费大量时间筛选。
                蓝色导航在线通过<strong>人工精选+分类整理</strong>的方式，为用户提供经过验证的优质网站资源，
                涵盖搜索引擎、社交媒体、视频娱乐、购物消费、学习教育、新闻资讯、工具资源、生活服务、科技IT等十大领域。
              </p>
              <p>
                我们的团队由互联网行业的资深从业者组成，对网站质量有着严格的审核标准。
                每一个收录的网站都经过<strong>多维度评估</strong>，确保其内容的可靠性、实用性和安全性。
                我们拒绝收录低质量、含恶意广告或存在安全风险的网站，为用户打造一个干净、放心的上网入口。
              </p>
            </div>
          </section>

          <section className="mb-14">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
              {stats.map((stat) => (
                <div
                  key={stat.label}
                  className="p-4 md:p-5 rounded-lg bg-background-100 border border-background-200/60 text-center"
                >
                  <div className="text-2xl md:text-3xl font-bold text-primary-600 mb-1">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>
          </section>

          <section className="mb-14">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-2">
              {t('reputation')}
            </h2>
            <p className="text-sm text-foreground-600 mb-6">
              来自用户和行业的真实评价
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {[
                {
                  name: '张先生',
                  role: '互联网从业者',
                  text: '蓝色导航在线已经成为我的浏览器首页，分类清晰、更新及时，找网站再也不用去搜索引擎翻好几页了。强烈推荐！',
                },
                {
                  name: '李女士',
                  role: '在校大学生',
                  text: '学习资源分类特别好用，中国大学MOOC、CSDN这些网站都是从这里发现的，对我的学习帮助很大。',
                },
                {
                  name: '王同学',
                  role: '自由职业者',
                  text: '工具资源分类收录了很多实用的在线工具，以前都要到处搜索，现在一个网站就搞定了，效率提升了不少。',
                },
              ].map((review) => (
                <div
                  key={review.name}
                  className="p-4 md:p-5 rounded-lg bg-background-100 border border-background-200/60"
                >
                  <div className="flex items-center gap-1 mb-3">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <div key={star} className="w-3.5 h-3.5 flex items-center justify-center">
                        <i className="ri-star-fill text-xs text-accent-500"></i>
                      </div>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    "{review.text}"
                  </p>
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">{review.name}</p>
                    <p className="text-xs text-foreground-500">{review.role}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="mb-10">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-6">
              {t('contactUs')}
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100/70 text-primary-600 flex-shrink-0">
                    <i className="ri-mail-line"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h3>
                    <p className="text-sm text-foreground-600">contact@lansedaohang.com</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-100/80 text-accent-600 flex-shrink-0">
                    <i className="ri-wechat-line"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-900 mb-1">微信公众号</h3>
                    <p className="text-sm text-foreground-600">蓝色导航在线</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-100/80 text-secondary-600 flex-shrink-0">
                    <i className="ri-time-line"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-900 mb-1">工作时间</h3>
                    <p className="text-sm text-foreground-600">周一至周五 9:00 - 18:00</p>
                  </div>
                </div>
              </div>

              <div className="p-5 rounded-lg bg-background-100 border border-background-200/60">
                <h3 className="text-sm font-semibold text-foreground-900 mb-4">网站收录申请</h3>
                <p className="text-xs text-foreground-600 leading-relaxed mb-4">
                  如果您有优质网站希望被收录，请发送邮件至 contact@lansedaohang.com，注明网站名称、网址和简介。
                  我们的审核团队会在3个工作日内完成评估并回复。
                </p>
                <div className="flex flex-wrap gap-2 text-xs text-foreground-500">
                  <span className="px-2.5 py-1 rounded-full bg-background-200/70">内容质量高</span>
                  <span className="px-2.5 py-1 rounded-full bg-background-200/70">无恶意广告</span>
                  <span className="px-2.5 py-1 rounded-full bg-background-200/70">稳定运行</span>
                  <span className="px-2.5 py-1 rounded-full bg-background-200/70">合法合规</span>
                </div>
              </div>
            </div>
          </section>
        </div>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'AboutPage',
              name: '关于蓝色导航在线',
              description: '蓝色导航在线是一个专注于网址导航与资源聚合的在线平台，为用户提供经过验证的优质网站资源。',
              publisher: { '@type': 'Organization', name: '蓝色导航在线' },
            }),
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: [
                {
                  '@type': 'Question',
                  name: '蓝色导航在线收录了哪些类型的网站？',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: '我们覆盖搜索引擎、社交媒体、视频娱乐、购物消费、学习教育、新闻资讯、工具资源、生活服务、科技IT等十大分类，精选40多个优质网站。',
                  },
                },
                {
                  '@type': 'Question',
                  name: '如何申请网站收录？',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: '请发送邮件至 contact@lansedaohang.com，注明网站名称、网址和简介，我们会在3个工作日内完成评估并回复。',
                  },
                },
                {
                  '@type': 'Question',
                  name: '蓝色导航在线是否免费使用？',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: '是的，蓝色导航在线完全免费使用，无需注册即可浏览所有收录的网站资源。',
                  },
                },
              ],
            }),
          }}
        />
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}